<template>
    <div class="abs full">
        <!-- 2d地图（保存状态） -->
        <keep-alive>
            <Map2D v-if="scenario !== 'globe'">
                <component
                        v-for="(comp, i) in components"
                        :key="i"
                        :is="comp"
                />
                <ztdt />
                <timeLine />
            </Map2D>

            <!-- 方案切换 -->
            <Scenario />

        </keep-alive>
    </div>
</template>

<script>
    import {MapView} from "../views/map2d/mapView";

    const Map2D = () => import('@/views/map2d/index.vue')
    import Scenario from '@/views/scenario/index.vue'
    import scenariomixin from '@/mixins/scenariomixin.js'
    import usermixin from '@/mixins/usermixin.js'
    import ztdt from '@/views/ztdt/index.vue'
    import timeLine from '@/views/ztdt/thematic-map/timeLine/index.vue'

    export default {
        components: { Map2D, ztdt, timeLine },
        mixins: [scenariomixin, usermixin],
        computed: {
        },
        data() {
            return {
                components: [Scenario],
                components3d: [],
                user: global.CONFIG.userConf,
            }
        },
        methods: {
        }
    }
</script>
<style lang='less'>
.bottomLogo{
    position: absolute;
    bottom: -18px;
    left: 20px;
    img{
        width: 120px;
    }
    .titleLogo{
        width: 400px;
        top: -16px;
        position: relative;
    }
}

</style>

